import { render } from "./HandleAddresses.vue?vue&type=template&id=5ed4c314"
import script from "./HandleAddresses.vue?vue&type=script&lang=js"
export * from "./HandleAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__